<template>
  <div class="row page_container">
    <div class="column content-box">
        <section class="details_container">
            <div>
                <div class="">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.ORDER_ID')}}</p>
                    <p class="order_value font_regular">{{order.id}}</p>
                    <p v-if="order.id" class="order_hint font_regular order_hint_warning">{{paymentNotify.message}}</p>
                </div>
            </div>
            <div>
                <div class="">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.STATUS')}}</p>
                    <p class="order_value font_regular">{{order.order_status.title}}</p>
                    <p v-if="order.delivery_service" class="order_hint font_regular order_hint_mute">
                        <fluent-icon icon="clock" class="order_hint_mute" />
                        <span>
                            {{$t('ORDER.DETAILS.INFO.STATUS_HINT')}} {{formatDateToCustomString(delivery_service.pickup_scheduled_at)}}
                        </span>
                    </p>
                </div>
            </div>
            <div>
                <div v-if="order.id && order.shipment_address">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.SHIP_ADDRESS')}}</p>
                    <p  v-if="order.id" class="order_value font_regular">
                        {{
                            [order.shipment_address.line1, order.shipment_address.city, order.shipment_address.country]
                            .filter(part => part)
                            .join(', ')
                        }}
                    </p>
                    <div>
                        <input
                            v-if="!order.id"
                            v-model="order.shipment_address.line1"
                            class="order_value font_regular edit_input"
                            type="text"
                            placeholder="Enter the first line of your address"
                        >

                    </div>
                </div>
            </div>


            <div>
                <div v-if="order.delivery_service && delivery_service.tracking_number">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.CONSIGNMENT')}}</p>
                    <p class="order_value font_regular">{{delivery_service.tracking_number}}</p>
                </div>
            </div>
            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.NAME')}}</p>
                <input
                    v-if="!order.id"
                    v-model="order.contact.name"
                    class="order_value font_regular edit_input"
                    type="text"
                    placeholder="Enter name of the contact"
                >
                <!-- <div v-if="$v.order.contact.name.$error" class="error mt_20">
                    <p class="message text_12 font_500">{{$t('ORDER.CREATE.Name.ERR')}}</p>
                </div> -->
                <p v-if="order.id" class="order_value font_regular">
                    {{contactName}}
                    <router-link v-if="orderConversationLink && display_conversation_id" :to="orderConversationLink">
                        <woot-button
                            size="small"
                            variant="clear"
                            color-scheme="primary"
                            icon="chat"
                        >
                        </woot-button>
                    </router-link>
                </p>
            </div>
            <div>
                <div v-if="order.delivery_service && order.delivery_service.price">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.DELVARY_PRICE')}}</p>
                    <p class="order_value font_regular">{{order.delivery_service.price}}</p>
                </div>
            </div>



            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.ORDER_TIME')}}</p>
                <p v-if="order.created_at" class="order_value font_regular">{{new Date(order.created_at).toGMTString().slice(0,-7)}}</p>
            </div>
            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.PHONE')}}</p>
                <p v-if="order.id" class="order_value font_regular">{{contactPhoneNumber}}</p>
                <div class="mt_4" :style="{width:'90%'}">
                    <InputSuggestions
                        v-if="!order.id"
                        v-model="searchPhone"
                        :suggestions="contactsList"
                        placeholder="Search phone number..."
                        type="tel"
                        @search="onPhoneEnter"
                        @select="onPhoneSelect"
                    >
                        <template #suggestion="{ item }">
                            <div class="custom-suggestion">
                            <p>{{ item.name }}</p>
                            <p>{{ item.phone_number }}</p>
                            </div>
                        </template>
                    </InputSuggestions>

                    <div v-if="$v.order.contact.phone_number.$error" class="error">
                        <p class="message text_12 font_500">{{$t('ORDER.CREATE.PHONE.ERR')}}</p>
                    </div>

                </div>
            </div>
            <div>
                <div v-if="order.delivery_service && order.delivery_service.status_text">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.DELVARY_STATUS')}}</p>
                    <p class="order_value font_regular">{{order.delivery_service.status_text}}</p>
                </div>
            </div>



            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.CURRENCY')}}</p>
                <p class="order_value font_regular">{{order.currency}}</p>
            </div>
            <!-- <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.REMARK')}}</p>
                <p class="order_value font_regular">{{order.remark}}</p>
            </div> -->
            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.PAID')}}</p>
                <input v-model="order.paid_total" class="order_value font_regular edit_input" :disabled="isOrderCancelOrComplete" type="number">
            </div>
            <div>
                <div v-if="order.delivery_service && order.delivery_service.failed_reason">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.DELVARY_FAIL_MSG')}}</p>
                    <p class="order_value font_regular">{{order.delivery_service.failed_reason}}</p>
                </div>
            </div>


            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.REMARK')}}</p>
                <p class="order_value font_regular">{{order.remark}}</p>
            </div>
            <!-- <div></div> -->
            <div>
                <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.REFUNDED')}}</p>
                <p class="order_value font_regular">{{order.refund_amount}}</p>
            </div>
            <div>
                <div v-if="order.delivery_service && order.delivery_service.tracking_url">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.DELVARY_TRAKING_URL')}}</p>
                    <p class="order_value font_regular">
                        <a v-if="order.delivery_service.tracking_url" class="order_value font_regular order_tracking" :href="order.delivery_service.tracking_url" target="_blank" rel="noopener noreferrer">
                        {{$t('ORDER.DETAILS.INFO.DELIVERY_TRAKING_BTN')}}
                        </a>
                    </p>
                </div>
            </div>

            <div>
                <div>
                    <p class="order_label font_regular"></p>
                    <p class="order_value font_regular"></p>
                </div>
            </div>
            <div>
                <div>
                    <p class="order_label font_regular"></p>
                    <p class="order_value font_regular"></p>
                </div>
            </div>
            <div>
                <div v-if="order.delivery_service && order.delivery_service.print_label_url">
                    <p class="order_label font_regular">
                        {{$t('ORDER.DETAILS.INFO.DELVARY_PRINT_URL')}}
                        <span class="tooltip_info">
                            <fluent-icon class="help_icon" icon="question-circle" />
                            <div class="tooltip_card" style="bottom:18px;">
                                <p
                                v-for="(info, index) in $t('ORDER.DETAILS.INFO.DELIVERY_HINTS')"
                                class="mb_0 font_12"
                                :key="index"
                                >{{info}}</p>
                            </div>
                        </span>
                    </p>
                    <p class="order_value font_regular">
                        <a v-if="order.delivery_service.print_label_url" class="order_value font_regular order_tracking" :href="order.delivery_service.print_label_url" target="_blank" rel="noopener noreferrer">
                        {{$t('ORDER.DETAILS.INFO.DELVARY_PRINT_BTN')}}
                        </a>
                    </p>
                </div>
            </div>

            <!--
            <div>
                <div>
                    <p class="order_label font_regular"></p>
                    <p class="order_value font_regular"></p>
                </div>
            </div>
            <div>
                <div>
                    <p class="order_label font_regular"></p>
                    <p class="order_value font_regular"></p>
                </div>
            </div>
            <div>
                <div v-if="order.delivery_service && delivery_service.tracking_number">
                    <p class="order_label font_regular">{{$t('ORDER.DETAILS.INFO.CONSIGNMENT')}}</p>
                    <p class="order_value font_regular">{{delivery_service.tracking_number}}</p>
                </div>
            </div>
            -->


        </section>




        <section class="padding-top mt_20">
            <div class="add_order_btns my_20">
                <woot-button
                    v-if="order.show_payment_button"
                    color-scheme="primary"
                    class-names="add_order_item_btn"
                    icon="send"
                    :disabled="isPaymentLinkSending"
                    :isLoading="isPaymentLinkSending"
                    @click="onSendPaymentLink"
                >
                    {{$t('ORDER.ACTION_BTNS.SEND_PAYMENT_LINK')}}
                </woot-button>
                <woot-button
                    v-if="order.show_payment_button"
                    color-scheme="primary"
                    class-names="add_order_item_btn"
                    icon="copy"
                    :isLoading="isPaymentLinkFetching"
                    :disabled="isPaymentLinkFetching"
                    @click="onCopyPaymentLink"
                >
                    {{$t('ORDER.ACTION_BTNS.COPY_PAYMENT_LINK')}}
                </woot-button>
                <woot-button
                    color-scheme="primary"
                    class-names="add_order_item_btn"
                    icon="add"
                    :disabled="isAddItemDisabled"
                    @click="onAddRow"
                    >
                        {{$t('ORDER.DETAILS.ADD_ITEM_BTN')}}
                </woot-button>
            </div>
            <OrderItemsTable
                :order_items="order.order_items"
                :cols="cols"
                :merchant="merchant"
                :order="order"
                :isLoading="isOrderLoading && !isUpdating"
                :paymentNotify="paymentNotify"
                :isOrderCancelOrComplete="isOrderCancelOrComplete"
                :isRefundBankFetching="isRefundBankFetching"
                :onRefundAmount="openRefundModal"
                :catalogItems="filteredCatalogItems"
                @on-sort-change="onSortChange"
                @onQuantityChange="onQuantityChange"
                @onPriceChange="onPriceChange"
                @onSelectProductItem="onSelectProductItem"
            />
        </section>


        <div>
            <woot-button
                v-if="order.id"
                color-scheme="primary"
                class="button--fixed-left-top"
                :isLoading="isUpdating"
                :isDisabled="isUpdating || isOrderCancelOrComplete || isUpdateBtnDisable"
                @click="updateOrderDetails"
            >
                Update
            </woot-button>
            <woot-button
                v-if="!order.id"
                color-scheme="primary"
                class="button--fixed-left-top"
                :isLoading="uiFlags.isCreating"
                :isDisabled="uiFlags.isCreating"
                @click="createNewOrder"
            >
                Create order
            </woot-button>
        </div>

        <div v-if="showRefundModal">
            <RefundModal
            :show="showRefundModal"
            :on-close="closeRefundModal"
            :order="order"
            :refundPaymentsBanks="refundPaymentsBanks"
            :onSuccess="onRefundSuccess"
            />
        </div>


    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderAPI from "../../../../api/orders";
import MerchantAPI from "../../../../api/merchant";
import alertMixin from 'shared/mixins/alertMixin';
import {ORDER_STATUSES} from "./order_constant"
import Button from '../../../../components/buttons/Button.vue';
import OrderItemsTable from './OrderItemsTable.vue';
import ContactApi from '../../../../api/contacts';
import CatalogAPI from "../../../../api/catalogue/catalog";
import RefundModal from "./RefundModal.vue"
import responsiveMixin from 'shared/mixins/responsiveMixin.js';
import OrderApi from 'dashboard/api/orders.js';
import InputSuggestions from 'components/ui/inputs/InputSuggestions.vue';
import { required, minLength,minValue  } from 'vuelidate/lib/validators';
import copy from 'copy-text-to-clipboard';
import {
  hasPressedCtrlAltAndIKeyForOrder,
  hasPressedCtrlAltAndPKeyForOrder,
  hasPressedCtrlAltAndLKeyForOrder,
  hasPressedCtrlAltAndOKeyForOrder,
  hasPressedCtrlAltAndUKeyForOrder,
} from 'shared/helpers/KeyboardHelpers';

export default {
    components:{
        Button,
        OrderItemsTable,
        RefundModal,
        InputSuggestions,
    },
    mixins: [alertMixin,responsiveMixin],
    data(){
        return{
            isOrderLoading:false,
            order: {
                order_items:[],contact:{},order_status:{},
                promo_code_input:"",
                new_promo_code:"",   // valid promo code
                deliveryModeItem: null,
            },
            ORDER_STATUSES,
            cols: [
                { key: 'item_name', name: 'Name', visible: true, type: 'default' },
                { key: 'currency', name: 'Currency', visible: true, type: 'default' },
                { key: 'quantity', name: 'Quantity', visible: true, type: 'default' },
                { key: 'item_price', name: 'Price', visible: true, type: 'default' },
                { key: 'total', name: 'Total', visible: true, type: 'default' },
                { key: 'available_inventory', name: 'Inventory', visible: true, type: 'default' },
                { key: 'action', name: 'Action', visible: true, type: 'default' },
            ],
            isUpdating: false,
            isMerchantFetched: false,
            merchant:{},
            catalog:{},
            display_conversation_id: null,
            showRefundModal: false,
            isStatusChangeByUser: false,
            refundPaymentsBanks:{
                bank_list:[],
                payments:[],
            },
            isRefundBankFetching:false,
            searchPhone:"",
            isPaymentLinkFetching:false,
            isPaymentLinkSending:false,
        }
    },
    computed:{
        ...mapGetters({
            currentUser: 'getCurrentUser',
            getAccount: 'accounts/getAccount',
            // categories: "catalog/getCatagories",
            catalogueItems: "catalog/getAllCatalogItems",
            contactsList: 'contacts/getContacts',
            uiFlags: "orders/getUIFlags",
        }),
        currentAccount(){
            return this.getAccount(this.currentUser.account_id);
        },
        orderConversationLink(){
            return `/app/accounts/${this.currentUser.account_id}/conversations/${this.display_conversation_id}`
        },
        contactName(){
            return this.order?.contact?.name || "";
        },
        contactPhoneNumber(){
            return this.order?.contact?.phone_number || "";
        },
        isAddItemDisabled(){
            const enableStatuslList = ['fresh','pending','packed','paid'];
            const isDisable = !enableStatuslList.includes(this.order?.order_status?.id);
            return isDisable;
        },
        isOrderCancelOrComplete(){
            if (this.isStatusChangeByUser) {
                return false;
            }
            const isInclude = ['cancelled','completed'].includes(this.order.order_status?.id)
            return isInclude
        },
        paymentNotify(){
            let message = "";
            let msgClass = "";
            let isRefund = false;
            if (!this.order.id) {
                return {
                    message,
                    msgClass,
                    isRefund,
                }
            }
            console.log(this.order);
            const paidTotal = isNaN(parseFloat(this.order.paid_total)) ? 0 : parseFloat(this.order.paid_total);
            switch (true) {
                case paidTotal < this.order.grand_total:
                    message =  this.$t('ORDER.DETAILS.NOTIFY_MSG.WAITING');
                    msgClass="pay_waiting_msg";
                    break;
                case paidTotal === this.order.grand_total:
                    message = this.$t('ORDER.DETAILS.NOTIFY_MSG.PAYMENT_RECEIVE');
                    msgClass="pay_receive_msg";
                    break;
                    // check if refund amount > 0
                // case this.order.paid_total > this.order.grand_total:
                case paidTotal > 0:
                    message = this.$t('ORDER.DETAILS.NOTIFY_MSG.REFUND');
                    msgClass="pay_refund_msg";
                    isRefund = true;
                    break;

                default:
                    break;
            }
            return {
                message,
                msgClass,
                isRefund,
            }
        },
        delivery_service(){
            return this.order.delivery_service || {
                tracking_number: "-",
            }
        },
        isUpdateBtnDisable(){
            if (this.order.promo_code_input) {
                if (this.order.new_promo_code) {
                    return false
                }
                return true
            }
            return false
        },
        filteredCatalogItems(){
            if (!this.catalogueItems?.length) return [];

            const allVariants = [];

            this.catalogueItems.forEach(item => {
                 // extract currency safely
                const [priceValue, currency] = item.price?.split(" ") || [0, ""];

                // base product (main variant)
                const mainVariant = {
                    id: item.id,
                    catalog_item_id: item.id,
                    title: item.title,
                    item_name: item.display_title,
                    image_link: item.image_link,
                    price: priceValue || '0',
                    item_price: priceValue || '0',
                    currency,
                    inventory: item.inventory,
                    available_inventory: item.available_inventory,
                    quantity: 0,
                    categories: item.categories || []
                };

                 // normalize variants
                const variants = [mainVariant, ...item.variants].map(variant => {
                    const [variantPrice, variantCurrency] = variant.price?.split(" ") || [0, currency];
                    return {
                    ...variant,
                    catalog_item_id: item.id,
                    item_name: variant.display_title || `${mainVariant.title}-${variant.title}`,
                    price: parseFloat(variantPrice) || 0,
                    item_price: parseFloat(variantPrice) || 0,
                    currency: variantCurrency || currency,
                    quantity: variant.quantity || 0,
                    available_inventory: variant.available_inventory ?? 0,
                    };
                });

                allVariants.push(...variants);
            });

            return allVariants;
        },
        isCatalogPaymentRequestSetup(){
            return !!this.catalog.messages?.order_aditional_payment;
        },
        // end computed
    },
    validations:{
        order:{
            contact: {
                // name: { required },
                phone_number: { required }
            },
        },
    },
    mounted(){
        // this.getOrderById(this.$route.params.order_id);
        // this.getCatalog();
        // this.$store.dispatch("catalog/getCatagories");
        // this.$store.dispatch("catalog/getCatalogProductItems");

        window.addEventListener("keydown", this.handleShortcuts);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handleShortcuts);
    },
    activated() {
        this.getCatalog();
        this.getMerchant();
        this.getOrderById(this.$route.params.order_id);
        this.$store.dispatch("catalog/getCatagories");
        this.$store.dispatch("catalog/getCatalogProductItems");
    },
    watch: {
        currentUser: {
            handler(newValue, oldValue) {
                this.getMerchant();
                if (!this.order.id && !this.order.account_id) {
                    this.getOrderById(this.$route.params.order_id);
                }
            },
            // immediate: true
        },
        currentAccount: {
            handler(newValue, oldValue) {
                if (!this.order.id && !this.order.account_id) {
                    this.getOrderById(this.$route.params.order_id);
                }
            },
            // immediate: true
        },
        '$route.params.order_id': {
            handler(newOrderId, oldOrderId) {
                if (newOrderId) {
                    this.getOrderById(newOrderId);
                }
            },
            // immediate: true
        }
    },
    methods:{
        async getOrderById(order_id){
            // if order_id=new then it is new order create
            if (order_id === "new"){
                // New order case — populate default values
                this.prefillOrder();
                return
            }

            this.isOrderLoading = true;
            try {
                const {data} = await OrderAPI.getOrderById(order_id);
                this.order = {
                    ...data,
                    promo_code_input:"",
                    new_promo_code:"",
                    deliveryModeItem:null,
                };
                // format status for option way
                this.order.order_status = ORDER_STATUSES.find(el=>el.id === this.order.order_status) || {}
                // set existItem = true at the beginning to keep separate the newly added items to remove id from payload
                this.order.order_items = this.order.order_items.map(el=>({...el,isExistItem:true}) )

                // get conversation id
                this.getConversationDisplayId();
            } catch (error) {
                this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.FETCH_ORDER_FAIL'));
            }finally{
                this.isOrderLoading = false;
            }
        },
        prefillOrder(){
            this.order = {
                id: null,
                order_status: ORDER_STATUSES.find(el => el.id === 'fresh') || { id: 'fresh', title: 'Fresh' },
                account_id: this.currentUser.account_id,
                grand_total: 0,
                paid_total: 0,
                order_total: 0,
                partial_payment: false,
                pending_partial_amount: 0,
                payment_link: null,
                extra_payment_link: null,
                refund_amount: 0,
                message_id: null,
                user_id: this.currentUser.id,
                contact_id: null,
                queue_no: 0,
                currency: this.currentAccount?.currency,
                tax_total: 0,
                shipment_address: {
                    city: "",
                    line1: "",
                    line2: "",
                    state: "",
                    country: "Malaysia",
                    postal_code:""
                },
                delivery: "self_collect",
                // payment_unique_id: "",
                // discarded_at: null,
                // charge_type: "credit",
                // credit_deducted: 0,
                remark: "",
                shipping_total: 0,
                discount_total: 0,
                promo_code: null,
                // payment_provider: "boost",
                order_items:[],
                contact: { name: "", phone_number: "" },
                deliveryModeItem:null,

            };
            // no conversation yet
            this.display_conversation_id = null;
        },
        onRefundSuccess(){
            this.getOrderById(this.$route.params.order_id);
        },
        async getMerchant(){
            if (this.isMerchantFetched && this.merchant?.logo_url) {
                return
            }
            try {
                if (!this.currentUser.accounts?.length) {
                    return
                }
                const merchantName = this.currentUser.accounts[0]?.name;
                if (merchantName) {
                    const {data} = await MerchantAPI.getMerchantByName(merchantName);
                    this.merchant = data;
                }
                this.isMerchantFetched = true;
            } catch (error) {
                this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.FETCH_MERCHANT_FAIL'));
            }
        },

        async updateOrderStatus(selectedOption){
            this.isStatusChangeByUser = true;
            // console.log({selectedOption,order:this.order});
            // try {
            //     const payload = {order_status:selectedOption.status_code}
            //     const {data} = await OrderAPI.updateOrderById(this.order.id,payload)
            //     this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.UPDATE_SUCCESS'));
            // } catch (error) {
            //     this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.UPDATE_FAIL'));
            // }
        },

        onSortChange(params){
            // console.log({params});
        },
        onQuantityChange(e,rowData,rowIndex){
            // console.log("Got in parent quantity",e,rowData);
            const quantity = parseInt(e.target.value||"0");

            // update the inventory
            const originalInventory = rowData.available_inventory + rowData.quantity;
            const newInventory = originalInventory - quantity;
            // console.log({originalInventory,newInventory});
            if (newInventory >= 0 && quantity <=originalInventory) {
                this.order.order_items[rowIndex].quantity = quantity;
                this.order.order_items[rowIndex].available_inventory = newInventory;
            }

            /*
            const originalInventory = rowData.inventory + rowData.quantity;
            const newInventory = originalInventory - quantity;
            console.log({originalInventory,newInventory});
            if (newInventory > 0) {
                this.order.order_items[rowIndex].inventory = newInventory;
            }
            */
            // console.log("QC item",this.order.order_items[rowIndex].available_inventory);
        },
        onPriceChange(e,rowData,rowIndex){
            const newPrice = parseFloat(e.target.value||"0");
            this.order.order_items[rowIndex].item_price = newPrice;
        },
        async updateOrderDetails(){
            // console.log("Update order = ",this.order);

            const updateOrderPayload = {
                currency : this.order.currency,
                paid_total: this.order.paid_total,
                order_items: this.order.order_items
                    .filter(el=>el.quantity > 0)
                    .map(({id,item_price,quantity,catalog_item_id,isExistItem})=>({
                        ...(isExistItem ? {id}:{}),
                        item_price,
                        quantity,
                        catalog_item_id
                    })),
                order_status: this.order.order_status.status_code,
                // remark: this.order.remark,
            }
            if (this.order.new_promo_code) {
                updateOrderPayload.promo_code = this.order.new_promo_code;
            }
            if (this.order.deliveryModeItem) {
                updateOrderPayload.delivery = 'delivery';
                updateOrderPayload.delyva_code = this.order.deliveryModeItem?.companyCode;
                updateOrderPayload.shipping_total = this.order.deliveryModeItem?.amount;
            }

            // console.log(updateOrderPayload);

             try {
                this.isUpdating = true;
                const result = await OrderAPI.updateOrderById(this.order.id,updateOrderPayload)
                await this.getOrderById(this.$route.params.order_id);
                //  get the order again
                 this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.UPDATE_SUCCESS'));
                this.isUpdating = false;
                this.isStatusChangeByUser = false;
            } catch (error) {
                // console.log(error);
                this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.UPDATE_FAIL'));
                this.isUpdating = false;
            }
        },
        closeRefundModal(){
            this.showRefundModal = false;
            this.refundPaymentsBanks = {
                bank_list:[],
                payments:[],
            }
        },
        async openRefundModal(){
            // call api and pass the value to props
            try {
                this.isRefundBankFetching = true;
                const {data} = await OrderApi.fetchAvailableRefund(this.order.id);
                // console.log(data);
                if (data.payments?.length) {
                    this.refundPaymentsBanks.payments = data.payments;
                }
                if (data.bank_list?.length) {
                    this.refundPaymentsBanks.bank_list = data.bank_list;
                }
                this.showRefundModal = true;
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            } finally{
                this.isRefundBankFetching = false;
            }

        },
        async getCatalog(){
            try {
                const {data} = await CatalogAPI.getDefaultCatalog();
                if (!data) {
                    return;
                }
                this.catalog = data;
                this.getConversationDisplayId();
            } catch (error) {
                // console.log("getCatalog = ",error);
                this.showAlert('error to get catalog');
            }
        },
        async getConversationDisplayId(){
            if (!this.catalog?.inbox_id || !this.order?.contact?.id) {
                return
            }

            try {
                const {data} = await ContactApi.getShopContactConversationUrl({
                    contact_id: this.order?.contact?.id,
                    inbox_id: this.catalog.inbox_id,
                })
                if (data?.length) {
                    this.display_conversation_id = data[0];
                }
            } catch (error) {
                this.showAlert('error to get catalog');
            }
        },
        formatDateToCustomString(dateString) {
            if (!dateString) {
                return
            }
            const date = new Date(dateString);
            const options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
                timeZone: 'UTC',
            };

            return new Intl.DateTimeFormat('en-US', options).format(date);
        },
        onAddRow(){
            const newItem = {
                id: null,
                item_name: "",
                item_price: 0,
                quantity: 0,
                created_at: "",
                updated_at: "",
                currency:  this.currentAccount?.currency, // "MYR", // account currency
                product_retailer_id: null,
                catalog_item_id: null,
                available_inventory: 0,
                isExistItem: false,
            }
            this.order.order_items.push(newItem);
        },
        onSelectProductItem({item,index}){
            this.$set(this.order.order_items, index, {
                ...item, isExistItem: false
            });
        },
        onPhoneEnter(value){
            this.order.contact.phone_number = value;
            this.$store.dispatch('contacts/search', {
                search: value,
            });
        },
        onPhoneSelect(contact){
            // console.log(contact);
            this.searchPhone = contact.phone_number;
            this.order.contact = contact;
            this.getConversationDisplayId();
        },
        async createNewOrder(){
            this.$v.order.contact.$touch();
            if (this.$v.order.contact.$invalid) {
                // this.showAlert(this.$t('ORDER.CREATE.PHONE.ERR'));
                return;
            }
            try {
                const payload = {
                    currency: this.currentAccount.currency,
                    order_items: this.order.order_items.filter(el=>el.quantity > 0)
                    .map(el=>({
                        item_price: el.item_price,
                        quantity: el.quantity,
                        catalog_item_id: el.catalog_item_id,
                    })),
                    contact: {
                        name: this.order.contact.name || "No name",
                        phone_number: this.order.contact.phone_number,
                    },
                    // for now only self_collect
                    shipment_address: {
                        line1: this.order.shipment_address.line1,
                        line2: "",
                        city: this.order.shipment_address.city,
                        state: this.order.shipment_address.state,
                        postalCode: this.order.shipment_address.postalCode,
                        country: this.order.shipment_address.country,
                        postal_code: this.order.shipment_address.postal_code,
                        // ...this.order.shipment_address,
                    },
                    delivery: "self_collect",
                    // deliveryModeItem: null,
                    // delyva_code: "DHLECDMY",
                    // shipping_total: 17.22
                }
                // add the delivery option here
                if (this.order.deliveryModeItem) {
                    payload.delivery = 'delivery';
                    payload.delyva_code = this.order.deliveryModeItem?.companyCode;
                    payload.shipping_total = this.order.deliveryModeItem?.amount;
                }

                const result = await this.$store.dispatch('orders/createNewOrder',payload);
                // console.log(result,"result");
                if (result.id) {
                    this.searchPhone = "";
                    // this.prefillOrder();
                    this.$router.push({
                        name: 'catalogue_order_details',
                        params: { accountId: this.currentUser.account_id, order_id:result.id }
                    });

                }
            } catch (error) {
                console.log(error);
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }
        },
        async onCopyPaymentLink(){
            if (!this.isCatalogPaymentRequestSetup) {
                this.showAlert(this.$t('ORDER.ACTION_BTNS.NO_PAY_NOTIFICATION_SETUP'));
                return
            }
            try {
                this.isPaymentLinkFetching = true;
                const {data} = await OrderApi.sendPaymentLink(this.order.id,{});
                copy(data.payment_links);
                this.showAlert(this.$t('ORDER.ACTION_BTNS.COPY_PAYMENT_LINK_ALERT'));
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            } finally{
                this.isPaymentLinkFetching = false;
            }
        },
        async onSendPaymentLink(){
            if (!this.isCatalogPaymentRequestSetup) {
                this.showAlert(this.$t('ORDER.ACTION_BTNS.NO_PAY_NOTIFICATION_SETUP'));
                return
            }
            try {
                this.isPaymentLinkSending = true;
                const {data} = await OrderApi.sendPaymentLink(this.order.id,{send_message:true});
                this.showAlert(this.$t('ORDER.ACTION_BTNS.SEND_PAYMENT_LINK_ALERT'));
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            } finally{
                this.isPaymentLinkSending = false;
            }
        },
        handleShortcuts(e) {
            if (!this.order) return;

            // Add Item → Ctrl + Alt + I
            if (hasPressedCtrlAltAndIKeyForOrder(e) && !this.isAddItemDisabled) {
                this.onAddRow();
            }

            // Send Payment Link → Ctrl + Alt + P
            if (hasPressedCtrlAltAndPKeyForOrder(e) && this.order.show_payment_button) {
                this.onSendPaymentLink();
            }

            // Copy Payment Link → Ctrl + Alt + L
            if (hasPressedCtrlAltAndLKeyForOrder(e) && this.order.show_payment_button) {
                this.onCopyPaymentLink();
            }

            // Create Order → Ctrl + Alt + O
            if (hasPressedCtrlAltAndOKeyForOrder(e) && !this.order.id) {
                this.createNewOrder();
            }

            // Update Order → Ctrl + Alt + U
            if (hasPressedCtrlAltAndUKeyForOrder(e) && this.order.id && !this.isOrderCancelOrComplete) {
                this.updateOrderDetails();
            }
        },
        // end method
    },

}
</script>

<style  lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/woot';

.status_select_wrapper{
    max-width: 200px;
}
.info_field{
    height: 60px;
    align-items: center;

    .pay_msg{
        // font-family: Figtree, Inter, sans-serif;
        // font-weight: 500;
        // font-size: 12px;
        border-radius: 4px;
        padding: 4px 8px;
        // color: #1F1F1F;
        margin-left: 10px;
    }
    .pay_waiting_msg{
        background-color: #FFECB2;
    }
    .pay_receive_msg{
        background-color: #F2E7FE;
    }
    .pay_refund_msg{
        background-color: #E5F1FF;
    }
}
.margin-bottom{
    margin-bottom: var(--space-small);
}
.margin-top{
    margin-top: var(--space-small);
}
.font_normal{
    font-size: 14px;
}
.disable_field{
    background-color: #ededed;
}

.product_details{
    display: grid;
    grid-template-columns: 2fr 1fr;
}
.details{
    // max-width: 580px;
}

.order_label{
    font-size: 12px;
    font-weight: 500;
    margin: 0;
}
.order_value{
    font-size: 16px;
    margin: 4px 0 0 0;
    font-weight: 500;
}
.order_hint{
    font-size: 12px;
    font-weight: 500;
    display: flex;
    margin: 4px 0 0 0;
    border-radius: 2px;
}
.order_hint_warning{
    max-width: fit-content;
    padding: 6px 12px;
    background: #F7FEE7;
}
.order_hint_mute{
    color: #858585;
}
.add_order_btns{
    width: fit-content;
    margin-left: auto;
}
.add_order_item_btn{
    font-weight: 600;
}
.order_tracking{
    color: #0A75F5;
}

.details_container{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    // gap: 10px;
    row-gap: 16px;
    column-gap: 10px;
    margin-top: -16px; // row-gap is adding space on top, to reduce that
    @include breakpoint(medium up) {
        grid-template-columns: repeat(3,1fr);
    }
}

.help_icon{
    position: absolute;
    top: 0;
    left: 8px;
    width: 15px;
    height: 15px;
}

.tooltip_info{
    position: relative;
    // max-width: 500px;
    &:hover {
        .tooltip_card {
            display: block;
        }
    }
    .tooltip_card{
        display: none;
        position: absolute;
        bottom: 12px;
        left: -17px;
        width: 100%;
        z-index: 1;
        min-width: 400px;
        padding: 5px 5px 5px 22px;
        background: #000;
        color: #fff;
        border-radius: 4px;
    }

}
.edit_input{
    // width: fit-content;
    width: 90%;
    &:disabled{
        background-color: #ededed;
    }
}
</style>

<style>
.font_normal .multiselect__tags .multiselect__single{
    font-size: 14px;
}
</style>


